// @ts-nocheck
import Link from "next/link";

export function Footer() {
  return (
    <footer 
      className="fixed bottom-0 left-1/2 -translate-x-1/2 z-[100] bg-background/75 dark:bg-slate-900/75 backdrop-blur-md rounded-t-full"
      style={{
        padding: '4px 24px',
      }}
    >
      <nav className="flex items-center justify-center gap-1.5 text-[10px] text-muted-foreground whitespace-nowrap" aria-label="quick links">
        <Link href="/docs/legal/terms" className="hover:underline hover:text-foreground transition-colors">
          Terms
        </Link>
        <span className="text-muted-foreground/50">·</span>
        <Link href="/docs/legal/privacy-policy" className="hover:underline hover:text-foreground transition-colors">
          Privacy
        </Link>
        <span className="text-muted-foreground/50">·</span>
        <span>Datadini Ltd · Company No. 08258574 · Since 2012</span>
      </nav>
    </footer>
  );
}
